module.exports = __webpack_public_path__ + "assets/img/team-button-active-2979ba5f.png";